import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const EventWrapper = styled.div`
  height: 100%;

  ${media.lg`
    display: flex;
    cursor: grab;
    align-items: center;
  `}
`

type InfoProps = {
  cut?: boolean
}

export const Info = styled.div<InfoProps>`
  flex-shrink: 0;

  ${({ theme }) => `
    margin-right: ${theme.space.mobile.base};
    margin-bottom: ${theme.space.mobile.nano};
  `}

  ${({ cut }) => media.lg`
    margin-bottom: 0;

    &:nth-child(1) {
      width: 50%;
    }

    &:nth-child(2) {
      width: 23%;
    }

    &:nth-child(3) {
      width: 27%;
    }

    ${
      cut &&
      `
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      flex-shrink: 1;
    `
    }
  `}
`

export const Text = styled.span`
  ${({ theme }) => `
    font-weight: ${theme.fontWeight.semibold}; 
  `}
`
